import axios from "axios";
import { CurrencyActions } from "./currencyAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

//get all Currency api
export const getAllCurrencyAsync = (search, searchText, type) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      let { skip, limit } = getState().currencyManagement;

      dispatch(CurrencyActions.getAllCurrencyStart());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/currency/getAllCurrencies`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          search: searchText,
          skip,
          limit,
        },
      });
      if (data.statusCode === 200) {
        return dispatch(CurrencyActions.getAllCurrencySuccess(data));
      }
      dispatch(CurrencyActions.getAllCurrencyError());
    } catch (error) {
      dispatch(CurrencyActions.getAllCurrencyError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

//create Currency api
export const addCurrencyAsync = (
  values,
  setSubmitting,
  resetForm,
  redirectBack
) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      dispatch(CurrencyActions.addCurrencyStart());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/currency/createCurrency`,
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      });

      if (data.statusCode === 201) {
        dispatch(CurrencyActions.addCurrencySuccess(data.data));
        setSubmitting(false);
        resetForm();
        redirectBack();
        return dispatch(
          showSuccessSnackbar("success", "Currency Added Successfully", 3000)
        );
      }
      dispatch(CurrencyActions.addCurrencyError());
      setSubmitting(false);
      return dispatch(showSuccessSnackbar("error", data.responseMessage, 3000));
    } catch (error) {
      dispatch(CurrencyActions.addCurrencyError(error));
      setSubmitting(false);
      resetForm();
      dispatch(showSuccessSnackbar("error", error.data.message, 3000));
    }
  };
};
//update Currency api
export const updateCurrencyAsync = (
  values,
  setSubmitting = () => {},
  resetForm = () => {},
  redirectBack = () => {}
) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      let { selectedCurrency } = getState().currencyManagement;

      // let CurrencyId =
      //   selectedCurrency == null ? values.id : selectedCurrency._id;
      // // only set for condition no use in data
      // delete values.id;
      dispatch(CurrencyActions.updateCurrencyStart());
      const { data } = await axios({
        method: "PUT",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/currency/editCurrency/${values._id}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      });
      if (data.statusCode === 200) {
        dispatch(CurrencyActions.updateCurrencySuccess(data));
        setSubmitting(false);
        resetForm();
        redirectBack();
        return dispatch(
          showSuccessSnackbar("success", "Currency Updated Successfully", 3000)
        );
      }
      dispatch(CurrencyActions.updateCurrencyError());
      setSubmitting(false);
      return dispatch(showSuccessSnackbar("error", data.responseMessage, 3000));
    } catch (error) {
      setSubmitting(false);
      resetForm();
      dispatch(CurrencyActions.updateCurrencyError(error));
      dispatch(showSuccessSnackbar("error", error.data.message, 3000));
    }
  };
};
//delete Currency api
export const deleteCurrencyAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      dispatch(CurrencyActions.deleteCurrencyStart());
      const { data } = await axios({
        method: "DELETE",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/currency/deleteCurrency/${id}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.statusCode === 200) {
        dispatch(CurrencyActions.deleteCurrencySuccess(data));
        return dispatch(
          showSuccessSnackbar("success", "Currency Deleted Successfully", 3000)
        );
      }
      dispatch(CurrencyActions.deleteCurrencyError());

      return dispatch(showSuccessSnackbar("error", data.responseMessage, 3000));
    } catch (error) {
      dispatch(CurrencyActions.deleteCurrencyError(error));
      dispatch(showSuccessSnackbar("error", error.data.message, 3000));
    }
  };
};
